import { Component, OnInit, ViewChild, ElementRef, Renderer2, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NavService } from '../nav.service';

@Component({
  selector: 'ae-landing',
  templateUrl: './landing.component.html',
  styles: []
})
export class LandingComponent {
  modalRef: BsModalRef;
  @ViewChild('navbar') public navbar: ElementRef;

  ngOnInit() {
    this.navService.position$.subscribe(this.changeNavBar.bind(this));
  }

  constructor(private modalService: BsModalService, private navService: NavService, private render: Renderer2) { }
  changeNavBar(position: string) {
    if (position === 'top') {
      this.render.setStyle(this.navbar.nativeElement, 'background-color', 'transparent');
    } else {
      this.render.setStyle(this.navbar.nativeElement, 'background-color', 'gainsboro');
    }
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
}
